<template>
  <div class="content">
    <div class="course-content">
      <div class="banner">
        <a-carousel arrows autoplay>
          <div
            slot="prevArrow"
            class="custom-slick-arrow"
            style="left: 0; zindex: 1"
          >
            <a-icon type="left-circle" />
          </div>
          <div
            slot="nextArrow"
            class="custom-slick-arrow"
            style="right: 0; zindex: 999"
          >
            <a-icon type="right-circle" />
          </div>
          <div
            style="height: 100%"
            :style="{ background: `${item.backgroud_color}` }"
            v-for="item in banner"
            :key="item.id"
            @click="todetails(item)"
          >
            <img
              :src="item.img_url"
              @onload="scalingImg(this)"
              class="banner-img"
            />
          </div>
        </a-carousel>
      </div>
      <div class="content-title container">精品课程</div>
      <div class="course container" v-if="liveCourseList.length > 0">
        <a-row :gutter="20">
          <a-col
            :span="6"
            class="course-box"
            style="padding-left: 14px; padding-right: 14px"
            v-for="item in liveCourseList"
            :key="item.id"
            @click="toDetails(item.id, 0)"
          >
            <div class="card">
              <CourseCard :item="item" />
            </div>
          </a-col>
        </a-row>
      </div>
      <div class="more" v-if="liveCourseList.length > 0">
        <a class="btn" @click="toPage('course')"
          >更多课程&nbsp;<a-icon type="right"
        /></a>
      </div>
      <div class="nothing" v-if="liveCourseList.length == 0">
        <img src="@img/nothing@2x.png" alt="" />
      </div>
    </div>
    <div class="teacher-content container">
      <div class="content-title">精英名师</div>
      <div class="teacher" v-if="teacherList.length > 0">
        <div class="teacher-list">
          <TeacherCard
            v-for="item in teacherList"
            :key="item.id"
            :item="item"
          />
        </div>
      </div>
      <div class="more" v-if="teacherList.length > 0">
        <a class="btn" @click="toPage('teacher')"
          >更多名师&nbsp;<a-icon type="right"
        /></a>
      </div>
      <div class="nothing" v-if="teacherList.length == 0">
        <img src="@img/nothing@2x.png" alt="" />
      </div>
    </div>
    <div class="info-content">
      <div class="content-title">课堂资讯</div>
      <div class="info-list container" v-if="newsList.length > 0">
        <div
          class="info-box"
          v-for="items in newsLists"
          :key="items.order_num"
          @click="tonews(items.id)"
        >
          <div class="info-card">
            <div class="info-cover">
              <img :src="items.img_url" alt />
            </div>
            <div class="info-details">
              <div class="title">{{ items.title }}</div>
              <div class="neiron">{{ items.brief }}</div>
              <div class="time">
                {{ items.create_time | dateformat("YYYY-MM-DD") }}
                <span
                  ><img src="@img/eye.png" alt />{{ items.viewer_num }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="more" v-if="newsList.length > 0">
        <a class="btn" @click="toPage('info')"
          >更多资讯&nbsp;<a-icon type="right"
        /></a>
      </div>
      <div class="nothing" v-if="newsList.length == 0">
        <img src="@img/nothing@2x.png" alt="" />
      </div>
    </div>
    <div class="voice-content container">
      <div class="content-title">
        学员心声
        <!-- <img
          src="@img/comment.png"
          v-if="isLogin"
          alt=""
          @click="toShowShades"
        /> -->
      </div>
      <div class="voice">
        <div
          class="voice-box"
          v-for="item in voiceList"
          :key="item.id"
          v-show="voiceList.length > 0"
        >
          <div class="voice-corver">
            <img v-if="item.img_url != null" :src="item.img_url" alt="" />
            <img
              v-else-if="item.img_url == null"
              src="@img/user_default.png"
              alt=""
            />
          </div>
          <div class="voice-detail">
            <div class="title">
              <p>
                <span class="span0">{{ item.user_name }}</span
                ><span class="span1">{{
                  item.create_time | dateformat("YYYY-MM-DD")
                }}</span>
              </p>
            </div>
            <div class="content" @click="showContent(item.content)">
              {{ item.content }}
            </div>
          </div>
        </div>
      </div>
      <div class="more" v-if="voiceList.length > 0">
        <a class="btn" @click="toPage('studentWish')" style="margin-right:18px">更多&nbsp;<a-icon type="right"/></a>
        <a class="btn" v-if="isLogin" @click="toShowShades">我要留言</a>
      </div>
      <div class="nothing" v-if="voiceList.length == 0">
        <img src="@img/nothing@2x.png" alt="" />
      </div>
    </div>
    <div class="shades" v-show="showShades" @click="cancel"></div>
    <div class="reply" v-show="showShades">
      <p>学员留言</p>
      <a-textarea
        class="reply-box"
        maxlength="101"
        @input="changeInput()"
        onchange="this.value=this.value.substring(0, 100)"
        onkeydown="this.value=this.value.substring(0, 100)"
        onkeyup="this.value=this.value.substring(0, 100)"
        v-model="message"
        placeholder="请输入评论"
      />
      <a-button class="reply-btn" type="primary" block @click="commitReply">提交</a-button>
      <a-button class="reply-btn" block @click="cancel">取消</a-button>
    </div>
    <a-alert
      :message="errmsg"
      v-if="errshow"
      class="errshow"
      type="error"
      showIcon
    />
  </div>
</template>
<script>
import CourseCard from "./components/CourseCard.vue";
import TeacherCard from "./components/TeacherCard.vue";
import { getCookie, group_sign } from "../../utils/tool";
import { mapState } from "vuex";
export default {
  name: "index",
  components: {
    CourseCard,
    TeacherCard,
  },
  data() {
    return {
      banner: [],
      newsList: [],
      videoCourseList: [],
      liveCourseList: [],
      teacherList: [],
      student_id: Number(getCookie("studentId")),
      user_name: getCookie("userAcount"),
      avatar: getCookie("avatar"),
      voiceList: [],
      token: getCookie("token"),
      showShades: false,
      message: "",
      errmsg: "",
      errshow: false,
    };
  },
  computed: {
    ...mapState(["isLogin"]),
    newsLists: function () {
      return this.sortKey(this.newsList, "order_num");
    },
  },
  methods: {
    showContent(item) {
      alert(item);
    },
    changeInput() {
      if (this.message.length > 100) {
        alert("输入字数不能超过100");
      }
    },
    sortKey(arr, key) {
      return arr.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },
    init() {
      let that = this;
      that.getBanner();
      that.getCourseList();
      that.getNewsList();
      that.getTeacherList();
      that.getVoiceList();
    },
    toShowShades() {
      if (this.isLogin) {
        this.showShades = true;
      } else {
        this.$root.Bus.$emit("showLogin");
      }
    },
    cancel() {
      this.message = "";
      this.showShades = false;
    },
    // 学员心声回复
    commitReply() {
      let that = this;
      var param = group_sign({
        student_id: that.student_id,
        user_name: that.user_name,
        content: that.message,
      });
      if (that.message && that.token) {
        this.$axios.post(this.$Api.apiSaveStuWishVoice, param).then((res) => {
          if (res.data.errcode == 0) {
            that.$message.success("留言成功！")
            that.message = "";
            that.showShades = false;
          } else if (res.data.errcode == 403) {
            that.$message.error(res.data.errmsg)
            let timeErrors = setTimeout(() => {
              this.$root.Bus.$emit("showLogin");
              clearTimeout(timeErrors);
            }, 2000);
          }
        });
      }
    },
    // 获取轮播图
    getBanner() {
      let that = this;
      var param = group_sign();
      this.$axios
        .post(this.$Api.apiGetBannerList, param)
        .then((res) => {
          that.banner = res.data.result.list;
        })
        .catch((error) => {
          console.log(error, ">>>>>>>>>");
        });
    },
    // 获取课程
    getCourseList() {
      let that = this;
      var param = group_sign({ number: 12 });
      this.$axios
        .post(this.$Api.apiGetIndexCourseList, param)
        .then((res) => {
          if (res.data.errcode == 0) {
            that.liveCourseList = res.data.result.list;
          } else {
            that.liveCourseList = [];
          }
        })
        .catch((error) => {
          console.log(error, ">>>>>>>>>");
        });
    },
    // 获取资讯分类
    getNewsKind() {
      let that = this;
      var param = group_sign({
        account_id: that.account_id,
        top_category_id: that.topId,
      });
      this.$axios
        .post(this.$Api.apiGetNewsKindList, param)
        .then((res) => {
          that.res = res.data.result.news_kinds;
          that.getNewsList(that.res[0].id);
        })
        .catch((error) => {
          console.log(error, ">>>>>>>>>");
        });
    },
    // 查询分类下的咨询
    getNewsList() {
      let that = this;
      var param = group_sign({ page_size: 6 });
      this.$axios
        .post(this.$Api.apiGetNewsKind, param)
        .then((res) => {
          that.newsList = res.data.result.list || [];
        })
        .catch((error) => {
          console.log(error, ">>>>>>>>>");
        });
    },
    // 查询名师列表
    getTeacherList() {
      let that = this;
      var param = group_sign({ limit_size: 8 });
      this.$axios
        .post(this.$Api.apiGetTeacherList, param)
        .then((res) => {
          that.teacherList = res.data.result.list || [];
        })
        .catch((error) => {
          console.log(error, ">>>>>>>>>");
        });
    },
    // 获取学员心声列表
    getVoiceList() {
      let that = this;
      var param = group_sign({ page_size: 4 });
      this.$axios.post(this.$Api.apiGetStudentWishList, param).then((res) => {
        if (res.data.errcode == 0) {
          that.voiceList = res.data.result.list || [];
        }
      });
    },
    tonews(id) {
      this.$router.push({
        path: "/page/info_details",
        query: { id: id },
      });
    },
    toDetails(id, type) {
      // if (this.isLogin) {
        this.$router.push({
          path: "/page/course_details",
          query: { course_id: id, course_type: type },
        });
      // } else {
      //   this.$root.Bus.$emit("showLogin");
      // }
    },
    toPage(path) {
      this.$router.push({ path: "/page/" + path });
    },
    todetails(item) {
      let link = [];
      if (item.link_url != "") {
        link = JSON.parse(item.link_url);
      } else {
        return;
      }
      let course_type;
      if (link.type == 1) {
        course_type = 0;
        if (this.isLogin) {
          this.$router.push({
            path: "/page/course_details",
            query: {
              course_id: link.params.course_id,
              course_type: course_type,
            },
          });
        } else {
          this.$root.Bus.$emit("showLogin");
        }
      } else if (link.type == 2) {
        this.$router.push({
          path: "/page/info_details",
          query: { id: link.params.news_id },
        });
      } else if (link.type == 3) {
        window.open(link.params.web_url);
      } else {
        return;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="less" scoped>
@import url("../../assets/less/index.less");
</style>
